import React from 'react'
import { capitalize } from 'lodash-es'
import { Medal } from 'lucide-react'

import { useFormat } from '~/components/hooks/use-format'
import { DashboardPagination } from '../dashboard-pagination'

type LeaderboardItemsProps = {
  items: {
    rank: string
    name: string
    isCurrentUser?: boolean
    teamName?: string
    points: number
    currency: string
  }[]
  rawLeaderboard: any
  getPrevOrNext: (action: 'prev' | 'next') => void
  isTeamSpecific?: boolean
}

export const LeaderboardItems: React.FC<LeaderboardItemsProps> = ({
  items,
  rawLeaderboard,
  getPrevOrNext,
  isTeamSpecific,
}: LeaderboardItemsProps) => {
  const { formatNumber } = useFormat()
  const rankStyles: Record<string, string> = {
    1: 'bg-yellow-400',
    2: 'bg-gray-400',
    3: 'bg-yellow-900 text-white',
  }

  const requestedPage = rawLeaderboard?.page + 1
  const totalNumberOfPages = Math.ceil(
    rawLeaderboard?.totalCount / rawLeaderboard?.size,
  )

  return (
    <div className="flex flex-col rounded-xl border bg-white p-6 shadow-sm">
      {items?.map((item: any) => (
        <div
          className={`hover-elevate flex flex-col items-center justify-between rounded-md p-4 md:flex-row ${
            item?.isCurrentUser ? 'border border-tenant-primary-color' : ''
          }`}
        >
          <div className="flex flex-wrap gap-3 md:items-center">
            <div
              className={`flex h-8 w-8 flex-shrink-0 items-center justify-center 
            rounded-full text-sm font-bold ${
              rankStyles?.[item?.rank]
                ? rankStyles?.[item?.rank]
                : 'text-muted-forground bg-gray-200 font-semibold'
            }`}
            >
              {item?.rank <= 3 ? (
                <Medal className="h-4 w-4" />
              ) : (
                <>{item?.rank}</>
              )}
            </div>
            <div
              className={`truncate font-medium ${
                item?.isCurrentUser ? 'text-tenant-primary-color' : ''
              }`}
            >
              {item?.name}
              {item?.isCurrentUser ? ` (You)` : ''}
              {item?.teamName && !isTeamSpecific ? (
                <div className="truncate text-xs text-gray-500">
                  {item?.teamName}
                </div>
              ) : null}
            </div>
          </div>
          <div className="flex-shrink-0 text-sm font-semibold">
            {formatNumber(item?.points)} {capitalize(item?.currency)}
          </div>
        </div>
      ))}
      {rawLeaderboard?.totalCount > 0 ? (
        <div className="mt-auto">
          <DashboardPagination
            totalNumberOfPages={totalNumberOfPages}
            requestedPage={requestedPage}
            getPrevOrNext={getPrevOrNext}
          />
        </div>
      ) : null}
    </div>
  )
}
